import { GetDirectionsCard } from '@/components/GetDirectionsCard'
import { useAppSelector } from '@/hooks/store'
import { AccessCard } from '@/routes/ThankYou/AccessCard'
import { AppDownload } from '@/routes/ThankYou/AppDownload'
import {
  appSlice,
  isKioskSelector,
  isWebsiteSelector,
  isWidgetSelector,
} from '@/store/appSlice'

export function ThankYouCards() {
  const isKiosk = useAppSelector(isKioskSelector)
  const isWebsiteMode = useAppSelector(isWebsiteSelector)
  const isWidgetMode = useAppSelector(isWidgetSelector)
  const isPool = useAppSelector(appSlice.selectors.isPool)

  const showAppDownload = isWebsiteMode && !isPool
  const showAccessCard = !isKiosk && !showAppDownload

  return (
    <div className="flex flex-col gap-4 lg:flex-col">
      {isWidgetMode ? (
        <GetDirectionsCard />
      ) : (
        <>
          {/*<PointsCard />*/}
          {showAppDownload ? <AppDownload /> : null}
          {showAccessCard ? <AccessCard /> : null}
        </>
      )}
    </div>
  )
}
